import { Frequency } from 'shared/lib/rrule';

export enum FormOptions {
  RRule = 'rrule',
  Target = 'target',
}

export enum FormUnit {
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}

export enum DayType {
  Day = 'day',
  WorkDay = 'work-day',
  WeekendDay = 'weekend',
}

export const formUnits = Object.values(FormUnit);

export const formUnitToRruleFreqMap: Record<FormUnit, Frequency> = {
  [FormUnit.Weeks]: Frequency.WEEKLY,
  [FormUnit.Months]: Frequency.MONTHLY,
  [FormUnit.Years]: Frequency.YEARLY,
};
